export default ($api) => ({
    thongtindiaphuong: (id,data) => {
        return $api.get(`thong-tin-dia-phuongs/${id}`,{ params: data })
},})
